(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-product-template"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.samish-buy'); if(!root)return;
  var gal=root.querySelector('#samish-gal-img');
  var vId=root.querySelector('#samish-variant-id');
  var cName=root.querySelector('#samish-color-name');
  var aPrice=root.querySelector('#samish-add-price');
  root.querySelectorAll('#samish-thumbs .thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('#samish-thumbs .thumb').forEach(function(x){x.classList.remove('active');});
      t.classList.add('active'); if(gal&&t.dataset.img)gal.src=t.dataset.img;
    });
  });
  root.querySelectorAll('.opt .sw').forEach(function(s){
    s.addEventListener('click',function(){

      root.querySelectorAll('.opt .sw').forEach(function(x){
        x.classList.remove('active');
      });

      s.classList.add('active');

      if(cName && s.dataset.name)
        cName.textContent = s.dataset.name;

      if(gal && s.dataset.img)
        gal.src = s.dataset.img;

      if(vId && s.dataset.variantId)
        vId.value = s.dataset.variantId;

      if(aPrice && s.dataset.price)
        aPrice.textContent = s.dataset.price;
    });
  });
  root.querySelectorAll('.qty').forEach(function(q){
    var b=q.querySelectorAll('button'),i=q.querySelector('input');
    if(b.length<2||!i)return;
    b[0].addEventListener('click',function(){i.value=Math.max(1,(parseInt(i.value)||1)-1);});
    b[1].addEventListener('click',function(){i.value=(parseInt(i.value)||1)+1;});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samish-buy"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.samish-buy'); if(!root)return;
  var gal=root.querySelector('#samish-gal-img');
  var vId=root.querySelector('#samish-variant-id');
  var cName=root.querySelector('#samish-color-name');
  var aPrice=root.querySelector('#samish-add-price');
  root.querySelectorAll('#samish-thumbs .thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('#samish-thumbs .thumb').forEach(function(x){x.classList.remove('active');});
      t.classList.add('active'); if(gal&&t.dataset.img)gal.src=t.dataset.img;
    });
  });
  root.querySelectorAll('.opt .sw').forEach(function(s){
    s.addEventListener('click',function(){
      root.querySelectorAll('.opt .sw').forEach(function(x){x.classList.remove('active');});
      s.classList.add('active');
      if(cName&&s.dataset.name)cName.textContent=s.dataset.name;
      if(gal&&s.dataset.img)gal.src=s.dataset.img;
      if(vId&&s.dataset.variantId)vId.value=s.dataset.variantId;
      if(aPrice&&s.dataset.price)aPrice.textContent=s.dataset.price;
    });
  });
  root.querySelectorAll('.qty').forEach(function(q){
    var b=q.querySelectorAll('button'),i=q.querySelector('input');
    if(b.length<2||!i)return;
    b[0].addEventListener('click',function(){i.value=Math.max(1,(parseInt(i.value)||1)-1);});
    b[1].addEventListener('click',function(){i.value=(parseInt(i.value)||1)+1;});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samish-colors"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.samish-colors .swatch-big').forEach(function(s){
    s.addEventListener('click',function(){
      var t=document.querySelector('.samish-buy .opt .sw[data-c="'+s.dataset.c+'"]');
      if(t)t.click();
      var anchor=document.querySelector('#samish-shop')||document.querySelector('.samish-buy');
      if(anchor)anchor.scrollIntoView({behavior:'smooth',block:'start'});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samish-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.samish-faq .acc-q').forEach(function(b){
    b.addEventListener('click',function(){b.parentElement.classList.toggle('open');});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samish-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.getElementById('menuToggle');
  const navLinks = document.getElementById('navLinks');
  
  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      navLinks.classList.toggle('active');
    });
    
    // Close menu when a link is clicked
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', function() {
        menuToggle.setAttribute('aria-expanded', 'false');
        navLinks.classList.remove('active');
      });
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.samish-header')) {
        menuToggle.setAttribute('aria-expanded', 'false');
        navLinks.classList.remove('active');
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('header-group');
    if (!header) return;

    document.documentElement.style.setProperty(
        '--header-height',
        header.offsetHeight + 'px'
    );

    window.addEventListener('scroll', function () {
        if (window.scrollY > 50) {
            header.classList.add('is-sticky');
            document.body.classList.add('header-sticky');
        } else {
            header.classList.remove('is-sticky');
            document.body.classList.remove('header-sticky');
        }
    });

    window.addEventListener('resize', function () {
        document.documentElement.style.setProperty(
            '--header-height',
            header.offsetHeight + 'px'
        );
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samish-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript ? document.currentScript.closest('.samish-page') : null;
  // Fallback: grab the last samish-page on the document
  if(!root){ var all = document.querySelectorAll('.samish-page'); root = all[all.length-1]; }
  if(!root) return;

  // Video play/pause
  var frame = root.querySelector('#videoFrame');
  var video = root.querySelector('#heroVideo');
  var playBtn = root.querySelector('#playBtn');
  if(frame && video && playBtn){
    var toggle = function(){
      if(video.paused){ video.play(); frame.classList.add('playing'); video.muted=false; video.controls=true; }
      else { video.pause(); frame.classList.remove('playing'); }
    };
    playBtn.addEventListener('click', toggle);
    video.addEventListener('ended', function(){ frame.classList.remove('playing'); });
  }

  var galImg = root.querySelector('#gal-img');

  // Gallery thumbnails
  root.querySelectorAll('#thumbs .thumb').forEach(function(t){
    t.addEventListener('click', function(){
      root.querySelectorAll('#thumbs .thumb').forEach(function(x){ x.classList.remove('active'); });
      t.classList.add('active');
      if(galImg && t.dataset.img) galImg.src = t.dataset.img;
    });
  });

  // Colour swatches in the buy box
  var variantInput = root.querySelector('#samish-variant-id');
  var colorName = root.querySelector('#color-name');
  var addPrice = root.querySelector('#add-price');
  root.querySelectorAll('.opt .sw').forEach(function(s){
    s.addEventListener('click', function(){
      root.querySelectorAll('.opt .sw').forEach(function(x){ x.classList.remove('active'); });
      s.classList.add('active');
      if(colorName && s.dataset.name) colorName.textContent = s.dataset.name;
      if(galImg && s.dataset.img) galImg.src = s.dataset.img;
      if(variantInput && s.dataset.variantId) variantInput.value = s.dataset.variantId;
      if(addPrice && s.dataset.price) addPrice.textContent = s.dataset.price;
      // sync gallery thumb highlight
      root.querySelectorAll('#thumbs .thumb').forEach(function(x){
        x.classList.toggle('active', x.dataset.img === s.dataset.img);
      });
    });
  });

  // Big swatches in the colours section -> jump to buy box + select
  root.querySelectorAll('.swatch-big').forEach(function(s){
    s.addEventListener('click', function(){
      var target = s.dataset.target; // 'pink' | 'navy'
      var match = root.querySelector('.opt .sw[data-c="'+target+'"]');
      if(match) match.click();
      var shop = root.querySelector('#samish-shop');
      if(shop) shop.scrollIntoView({behavior:'smooth', block:'start'});
    });
  });

  // Quantity steppers
  root.querySelectorAll('.qty').forEach(function(q){
    var btns = q.querySelectorAll('button');
    var i = q.querySelector('input');
    if(btns.length < 2 || !i) return;
    btns[0].addEventListener('click', function(){ i.value = Math.max(1, (parseInt(i.value)||1) - 1); });
    btns[1].addEventListener('click', function(){ i.value = (parseInt(i.value)||1) + 1; });
  });

  // FAQ accordion
  root.querySelectorAll('.acc-q').forEach(function(b){
    b.addEventListener('click', function(){ b.parentElement.classList.toggle('open'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["samish-video"] && !Shopify.designMode) return;
  try {
    
(function(){
  var f = document.getElementById('samish-videoFrame'),
      v = document.getElementById('samish-heroVideo'),
      b = document.getElementById('samish-playBtn');

  if(!f || !v) return;

  // Autoplay immediately
  v.play().then(function(){
    f.classList.add('playing');
  }).catch(function(){});

  // Optional: Click video to toggle sound
  if(b){
    b.style.display = 'none';
  }
})();

  } catch(e) { console.error(e); }
})();
})();
